import * as React from "react";
const SvgSubtract = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.136 12v1.248h19.728v-2.496H2.136V12Z", fill: "currentColor" })));
export default SvgSubtract;
